import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import ROUTES from 'utils/routes.js';

import { useUser } from 'utils/userContext';

function NotFound() {
    const navigatePage = useNavigate()

    const { user, loading } = useUser();


    return (
        <div className='Roadmap grid-rows-split-small break-small:grid-rows-split-main h-full bg-background text-white text-center grid  overflow-hidden' >

            {/* <h1 className='px-10 break-small:px-0 w-full break-small:w-3/4 break-big:w-full font-bold text-center break-small:text-left text-[5vw] break-small:text-5xl mb-[4vh] break-big:mb-[8vh]'>Question</h1> */}
            <div className="Lessons max-h-full overflow-y-auto w-full flex justify-center items-center gap-32">
                <h1 className=' font-bold text-center text-[4rem] break-small:text-[2.5rem]'>404: Page not found!</h1>
            </div>
            <div className="Info w-full h-[160px] py-3 break-small:py-0 px-4 break-big:px-32 break-small:h-[110px] border-t-2 bg-background border-border flex flex-col break-small:flex-row justify-around items-center ">
                <button onClick={() => { navigatePage((!loading && user) ? ROUTES.LESSONS : ROUTES.LANDING) }} className='border-[3px] w-full break-small:w-fit border-border px-16 py-3 rounded-3xl text-border text-2xl' >RETURN HOME</button>
            </div>

        </div>
    )
}

export default NotFound